import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import DeclaracionTrabajadorCuentaPropia from './DeclaracionTrabajadorCuentaPropia';
import useGetDeclaracionTrabajadorCuentaPropiaByID from 'services/record/DeclaracionTrabajadorCuentaPropia/useGetDeclaracionTrabajadorCuentaPropiaByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialDeclaracionTrabajadorCuentaPropia = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetDeclaracionTrabajadorCuentaPropiaByID, errorGetDeclaracionTrabajadorCuentaPropiaByID, getDeclaracionTrabajadorCuentaPropiaByID, loadingGetDeclaracionTrabajadorCuentaPropiaByID, successGetDeclaracionTrabajadorCuentaPropiaByID } = useGetDeclaracionTrabajadorCuentaPropiaByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getDeclaracionTrabajadorCuentaPropiaByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Declaración trabajador cuenta propia'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetDeclaracionTrabajadorCuentaPropiaByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <DeclaracionTrabajadorCuentaPropia dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialDeclaracionTrabajadorCuentaPropia